import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import Skeleton from 'vue-loading-skeleton';
import CKEditor from 'ckeditor4-vue';


Vue.use(Skeleton)
Vue.use(CKEditor);
import '@/assets/js/bootstrap.bundle.min.js'
Vue.use(VueAxios, axios)
window.toastr = require('toastr');

import { ServerTable, ClientTable } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bootstrap4', 'default');
Vue.use(ServerTable, {}, false, 'bootstrap4', 'default');

import vRut from 'v-rut';
Vue.use(vRut)
Vue.use(BootstrapVueIcons, {})

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

import VCalendar from 'v-calendar';

// Agregamos la URL base de nuestra API
// axios.defaults.baseURL = 'https://instruccion-lms.test/';
// axios.defaults.baseURL = 'https://instruccion-lms-qa.vgroup.cl/';
//axios.defaults.baseURL = 'https://instruccion-lms.vgroup.cl/';
//axios.defaults.baseURL = 'https://instruccion-lms.test/';



//axios.defaults.baseURL = 'http://coordinacion-cliente.test/';
//axios.defaults.baseURL = 'https://coordinacion-cliente-api.vgroup.cl/';


axios.defaults.baseURL = 'https://api-lms3.vgroup.cl/AdminCliente/';
// axios.defaults.baseURL = 'https://api-lms3.test/AdminCliente/';





import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/css/icons.min.css';
import '@/assets/css/app.min.css';

import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "jszip";
import "pdfmake";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";


Vue.config.productionTip = false
Vue.use(BootstrapVue);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')